import React, { Component } from 'react'
import Icon from './Icon'

class Close extends Component {
  render () {
    return (
      <Icon {...this.props}>
        <svg
          x='0px'
          y='0px'
          viewBox='0 0 14 14'
          enableBackground='new 0 0 14 14'
        >
          <g>
            <polygon
              fill={this.props.color || '#FFFFFF'}
              points='14,1.41 12.59,0 7,5.59 1.41,0 0,1.41 5.59,7 0,12.59 1.41,14 7,8.41 12.59,14
          				14,12.59 8.41,7'
            />
          </g>
        </svg>
      </Icon>
    )
  }
}

export default Close
